export default {
  roundOnly: true,
  checkoutFormVariant: 'd',
  planSet: 'pricing-25',
  growthbookFeatures: ['supp', 'thankyou_tips'],
};
